<template>
  <div class="m-b-20 attr table-first-style" style="margin-top: 20px">
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left">
        <i class="el-icon-star-on" style="margin-left:32px;margin-right:0;"></i>
        <span class="order-list-search-span">常用属性</span>
      </el-col>
      <el-col :span="20">
        <el-button type="primary" class="add-btn btn-right" @click="addAttr">新建属性</el-button>
        <el-button type="primary" class="add-btn" style="margin-right: 12px" @click="openBothAttr">选择公共属性</el-button>
      </el-col>
    </el-row>
    <div class="set-attr-normal-content">
      <div class="normal-title">
        <div>属性名称-类型</div>
        <div>属性分值</div>
        <div>是否必填</div>
        <div>操作</div>
      </div>
      <div v-loading="loadingTable">
      <div class="blankOrder" v-if="normal.length === 0">没有更多数据了</div>
      <draggable class="list-group" :list="normal" @change="log">
        <div class="normal-item" v-for="item in normal" :key="item.identity">
          <div>
            {{ item.name }}-
            <span v-if="item.type === 'input'">文本</span>
            <span v-if="item.type === 'addressPicker'">地址</span>
            <span v-if="item.type === 'select'">单个选择列表</span>
            <span v-if="item.type === 'multipleSelect'">多个选择列表</span>
            <span v-if="item.type === 'datePicker' || item.type === 'dateTimePicker'">时间</span>
            <span v-if="item.type === 'number'">数值</span>
            <span v-if="item.type === 'model'">模型</span>
          </div>
          <div>
            <span v-if="item.isInner === 1">--</span>
            <span v-else>{{ item.score }}</span>
          </div>
          <div>
            <span v-if="item.required === 0">非必填</span>
            <span v-if="item.required === 1">必填</span>
          </div>
          <div>
            <span class="op-link" @click="setCustomerAttribute(0, item)">
              设为非常用
            </span>
            <span class="op-link" @click="openDialog(item)" v-if="item.isEdit === 1 && item.isInner === 0">
              编辑
            </span>
            <span v-if="item.isInner === 0" class="op-link" @click="removeCustomerAttribute(item)">
              删除
            </span>
          </div>
        </div>
      </draggable>
      </div>
    </div>
      <!--<el-table-->
      <!--ref="multipleTable"-->
      <!--:data="normal"-->
      <!--v-loading="loading"-->
      <!--class="customer-procuct-table">-->
      <!--<el-table-column-->
        <!--prop="name"-->
        <!--label="属性名称">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--label="属性分值">-->
        <!--<template slot-scope="scope">-->
          <!--<div v-if="scope.row.identity === 'stage_id' || scope.row.identity === 'is_vip' || scope.row.identity === 'source_id' || scope.row.identity === 'create_time' || scope.row.identity === 'update_time'">&#45;&#45;</div>-->
          <!--<div v-else>{{ scope.row.score }}</div>-->
        <!--</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--label="操作"-->
        <!--width="200">-->
        <!--<template slot-scope="scope">-->
          <!--<div class="op-link" @click="setCustomerAttribute(scope.row, 0)">-->
            <!--设为非常用-->
          <!--</div>-->
          <!--<div class="op-link" @click="openDialog(scope.row)" v-if="scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'">-->
            <!--编辑-->
          <!--</div>-->
          <!--<div v-if="scope.row.is_system === 0 && scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'" class="op-link" @click="removeCustomerAttribute(scope.row)">-->
            <!--删除-->
          <!--</div>-->
        <!--</template>-->
      <!--</el-table-column>-->
    <!--</el-table>-->
    <el-row class="search-title common-table-top" style="margin-top: 20px">
      <el-col :span="4" style="text-align: left">
        <i class="el-icon-star-off"  style="margin-left:32px;margin-right:0;"></i>
        <span class="order-list-search-span">非常用属性</span>
      </el-col>
    </el-row>
    <div class="set-attr-normal-content">
      <div class="normal-title">
        <div>属性名称-类型</div>
        <div>属性分值</div>
        <div>是否必填</div>
        <div>操作</div>
      </div>
      <div v-loading="loadingTable">
      <div class="blankOrder" v-if="notNormal.length === 0">没有更多数据了</div>
      <draggable class="list-group" :list="notNormal" @change="log">
        <div class="normal-item" v-for="item in notNormal" :key="item.identity">
          <div>
            {{ item.name }}-
            <span v-if="item.type === 'input'">文本</span>
            <span v-if="item.type === 'addressPicker'">地址</span>
            <span v-if="item.type === 'select'">单个选择列表</span>
            <span v-if="item.type === 'multipleSelect'">多个选择列表</span>
            <span v-if="item.type === 'datePicker' || item.type === 'dateTimePicker'">时间</span>
            <span v-if="item.type === 'number'">数值</span>
            <span v-if="item.type === 'model'">模型</span>
          </div>
          <div>
            <span v-if="item.isInner === 1">--</span>
            <span v-else>{{ item.score }}</span>
          </div>
          <div>
            <span v-if="item.required === 0">非必填</span>
            <span v-if="item.required === 1">必填</span>
          </div>
          <div>
            <span class="op-link" @click="setCustomerAttribute(1, item)">
              设为常用
            </span>
            <span class="op-link editColor" @click="openDialog(item)" v-if="item.isEdit === 1 && item.isInner === 0">
              编辑
            </span>
            <span v-if="item.isInner === 0" class="op-link deleteColor" @click="removeCustomerAttribute(item)">
              删除
            </span>
          </div>
        </div>
      </draggable>
      </div>
    </div>
      <!--<el-table-->
      <!--ref="multipleTable"-->
      <!--:data="notNormal"-->
      <!--class="customer-procuct-table">-->
      <!--<el-table-column-->
        <!--prop="name"-->
        <!--label="属性名称">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--label="属性分值">-->
        <!--<template slot-scope="scope">-->
          <!--<div v-if="scope.row.identity === 'stage_id' || scope.row.identity === 'is_vip' || scope.row.identity === 'source_id' || scope.row.identity === 'create_time' || scope.row.identity === 'update_time'">&#45;&#45;</div>-->
          <!--<div v-else>{{ scope.row.score }}</div>-->
        <!--</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--label="操作"-->
        <!--prop=""-->
        <!--width="200">-->
         <!--<template slot-scope="scope">-->
           <!--<div class="op-link" @click="setCustomerAttribute(scope.row, 1)">-->
             <!--设为常用-->
           <!--</div>-->
           <!--<div class="op-link" @click="openDialog(scope.row)" v-if="scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'">-->
             <!--编辑-->
           <!--</div>-->
           <!--<div v-if="scope.row.is_system === 0 && scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'" class="op-link" @click="removeCustomerAttribute(scope.row)">-->
             <!--删除-->
           <!--</div>-->
        <!--</template>-->
      <!--</el-table-column>-->
    <!--</el-table>-->
    <!--</draggable>-->
     <!--编辑弹窗-->
    <el-dialog class="cellDialog base-dialog set-attr-dia" title="编辑客户属性" :visible.sync="editdialog" width="530px">
      <el-form ref="editForm" :model="editForm" :rules="ruless">
        <el-form-item label="评分标准:" :label-width="addLabelWidth" prop="score">
          <el-input class="stockInput" type="text" v-model="editForm.score" auto-complete="off" placeholder="输入评分标准"></el-input>
        </el-form-item>
        <el-form-item label="属性名称:" :label-width="addLabelWidth" prop="name">
          <el-input maxlength="20" class="stockInput" placeholder="输入属性名称" type="text" v-model="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="属性ID:" :label-width="addLabelWidth" prop="identity">
          <el-input disabled class="stockInput" placeholder="输入字段标识" type="text" v-model="editForm.identity" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label-width="addLabelWidth" label="属性类型:" prop="attr_type">
          <el-select disabled v-model="editForm.attr_type" filterable placeholder="请选择属性类型" style="width:100%">
            <el-option
              v-for="item in attr_types"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="is-need" label="是否必填:" :label-width="addLabelWidth">
          <el-checkbox v-model="editForm.checked">必填</el-checkbox>
        </el-form-item>
      </el-form>
      <el-form ref="editForm" :model="editForm" style="margin-top: 20px">
        <!--关联类型-->
        <div v-if="editForm.type === 'model'" :class="addMore ? 'addMore' : 'normal'">
          <el-form-item class="about-content" label="关联客户类型:" :label-width="addLabelWidth">
            <el-select @change="chooseEditAttrType" v-model="editForm.about_cus_type" filterable placeholder="请选择受众类型" class="about-fir">
              <el-option
                v-for="item in about_cus_types"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="editForm.about_real_content" filterable placeholder="请选择属性类型" class="about-sec">
              <el-option
                v-for="item in about_content"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!--时间-->
        <div v-if="editForm.type === 'time'">
          <el-form-item label="时间类型:" :label-width="addLabelWidth">
            <div class="date-type">
              <div style="cursor: inherit" :key="index" :class="dateTabIndex === index ? 'dateChoose' : ''" v-for="(item, index) in timeChoose">
                {{ item.name }}
              </div>
            </div>
            <div class="description-date" style="padding-left: 0">
              <div v-if="dateTabIndex === 0">如：1977-01-01</div>
              <div v-if="dateTabIndex === 1">如：1977-01-01 23:59:59</div>
            </div>
          </el-form-item>
        </div>
        <!--单个选择列表-->
        <div v-if="editForm.type === 'select'" :class="editRadioMore ? 'addMore' : 'normal'" id="set-attr-id-three">
          <div class="radio-item set-attr-content" :key="index" v-for="(item, index) in editForm.radio" style="padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="请输入选项" type="text" v-model="editForm.radio[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div class="removeSelectItem" @click="removeEditRadioItem(index)">X</div>
          </div>
          <div>
            <div class="addSelectItem" @click="addEditRadioItem">
              <i class="el-icon-circle-plus-outline"></i>
              增加可选项
            </div>
          </div>
        </div>
        <!--多个选择列表-->
        <div v-if="editForm.type === 'multipleSelect'" :class="editCheckBoxMore ? 'addMore' : 'normal'" id="set-attr-id-four">
          <div class="checkBox-item set-attr-content" :key="index" v-for="(item, index) in editForm.checkBox" style="padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="输入选项" type="text" v-model="editForm.checkBox[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div class="removeSelectItem" @click="removeEditCheckBoxItem(index)">X</div>
          </div>
          <div>
            <div class="addSelectItem" @click="addEditCheckBoxItem">
              <i class="el-icon-circle-plus-outline"></i>
              增加可选项
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabledEdit" class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="confirmEditAttr">确 定</el-button>
      </div>
    </el-dialog>
    <!--添加弹窗-->
    <el-dialog class="cellDialog base-dialog set-attr-dia" title="新建属性" :visible.sync="adddialog" width="530px">
      <el-form ref="addForm" :model="addForm" :rules="rules">
        <el-form-item label="评分标准:" :label-width="addLabelWidth" prop="score">
          <el-input type="text" class="stockInput" v-model="addForm.score" auto-complete="off" placeholder="输入评分标准"></el-input>
        </el-form-item>
        <el-form-item label="属性名称:" :label-width="addLabelWidth" prop="name">
          <el-input maxlength="20" class="stockInput" placeholder="输入属性名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="属性ID:" :label-width="addLabelWidth" prop="identity">
          <el-input class="stockInput" placeholder="输入字段标识" type="text" v-model="addForm.identity" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label-width="addLabelWidth" label="属性类型:" prop="attr_type">
          <el-select @change="chooseAttrType" v-model="addForm.attr_type" filterable placeholder="请选择属性类型" style="width:100%">
            <el-option
              v-for="item in attr_types"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="is-need" label="是否必填:" :label-width="addLabelWidth">
          <el-checkbox v-model="addForm.checked">必填</el-checkbox>
        </el-form-item>
      </el-form>
      <el-form ref="addForm" :model="addForm" style="margin-top: 20px" :rules="rules">
        <!--关联类型-->
        <div v-if="addForm.type === 'model'" :class="addMore ? 'addMore' : 'normal'">
          <el-form-item class="about-content" label="关联客户类型:" :label-width="addLabelWidth">
            <el-select @change="chooseAttrAboutType" v-model="addForm.about_cus_type" filterable placeholder="请选择受众类型" class="about-fir">
              <el-option
                v-for="item in about_cus_types"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="addForm.about_real_content" filterable placeholder="请选择属性类型" class="about-sec">
              <el-option
                v-for="item in about_content"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!--时间-->
        <div v-if="addForm.type === 'time'">
          <el-form-item label="时间类型:" :label-width="addLabelWidth">
            <div class="date-type">
              <div :key="index" :class="dateTabIndex === index ? 'dateChoose' : ''" @click="chooseDateType(index, item)" v-for="(item, index) in timeChoose">
                {{ item.name }}
              </div>
            </div>
            <div class="description-date" style="padding-left: 0">
              <div v-if="dateTabIndex === 0">如：1977-01-01</div>
              <div v-if="dateTabIndex === 1">如：1977-01-01 23:59:59</div>
            </div>
          </el-form-item>
        </div>
        <!--单个选择列表-->
        <div v-if="addForm.type === 'select'" :class="radioMore ? 'addMore' : 'normal'" id="set-attr-id">
          <div class="radio-item set-attr-content" :key="index" v-for="(item, index) in addForm.radio" style="padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="请输入选项" type="text" v-model="addForm.radio[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div class="removeSelectItem" @click="removeRadioItem(index)">X</div>
          </div>
          <div>
            <div class="addSelectItem" @click="addRadioItem">
              <i class="el-icon-circle-plus-outline"></i>
              增加可选项
            </div>
          </div>
        </div>
        <!--多个选择列表-->
        <div v-if="addForm.type === 'multipleSelect'" :class="checkBoxMore ? 'addMore' : 'normal'" id="set-attr-id-two">
          <div class="checkBox-item set-attr-content" :key="index" v-for="(item, index) in addForm.checkBox" style="padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="输入选项" type="text" v-model="addForm.checkBox[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div class="removeSelectItem" @click="removeCheckBoxItem(index)">X</div>
          </div>
          <div>
            <div class="addSelectItem" @click="addCheckBoxItem">
              <i class="el-icon-circle-plus-outline"></i>
              增加可选项
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabled" class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--选择公共属性弹窗-->
    <el-dialog class="cellDialog both-dialog" title="选择公共属性" :visible.sync="chooseBothdialog" width="700px">
      <el-select v-model="groupId" @change="changeGroup" filterable placeholder="请选择属性分组" class="set-attr-group">
        <el-option
          v-for="item in groups"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-transfer
        class="trans-content"
        filterable
        filter-placeholder="请输入查询内容"
        v-model="rightData"
        :titles="['受众属性', '已选属性']"
        :button-texts="['加入左侧', '加入右侧']"
        @change="chooseTrans"
        :data="leftData">
      </el-transfer>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="chooseBothdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="confirmAttrTransAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { getCustomerAttributeList, editCustomerAttribute, setCustomerAttributeIsNormal } from '@/api/customer.js'
import { setTransAddDel, getSetAttrGroupList, attrTransAdd, attrTransDel, getCusAttrList, addCustomerAttr, editCustomerAttr, customerAttrIsNormal, getCusTypes, deleteCustomerAttr, getCusAttrLeftList, sortCustomerAttr } from '@/api/set.js'
export default {
  name: 'customerAttribute',
  components: {
    draggable
  },
  data () {
    return {
      groups: [],
      groupId: 0,
      disabled: false,
      disabledEdit: false,
      data2: [],
      rightData: [],
      leftData: [],
      about_cus_types: [
        {
          id: 'agency',
          name: '经销商'
        },
        {
          id: 'tuangou',
          name: '团购商'
        }
      ],
      about_content: [],
      attr_types: [
        {
          id: 'input',
          name: '文本'
        },
        {
          id: 'number',
          name: '数值'
        },
        {
          id: 'time',
          name: '时间'
        },
        {
          id: 'addressPicker',
          name: '地址'
        },
        {
          id: 'select',
          name: '单个选择列表'
        },
        {
          id: 'multipleSelect',
          name: '多个选择列表'
        },
        {
          id: 'model',
          name: '关联模型'
        }
      ],
      loading: true,
      loadingTable: false,
      isSystem: '',
      hide: false,
      productName: '',
      saleType: '',
      isOnSale: '',
      normal: [],
      notNormal: [],
      editdialog: false,
      chooseBothdialog: false,
      area: '',
      currentPage: 1,
      limit: 15,
      totalCount: 0,
      page: 1,
      addLabelWidth: '100px',
      addForm: {
        name: '',
        score: '',
        type: 'input',
        realtype: 'datePicker',
        identity: '',
        is_normal: 1,
        select: [''],
        checkBox: [''],
        option: [],
        radio: [''],
        dateType: '',
        attr_type: '',
        checked: false,
        about_cus_types: '',
        about_real_content: ''
      },
      editForm: {
        name: '',
        score: '',
        type: 'input',
        realtype: 'datePicker',
        identity: '',
        is_system: 1,
        option: [],
        select: [],
        checkBox: [],
        radio: [],
        dateType: '',
        attr_type: '',
        checked: false,
        about_cus_types: '',
        about_real_content: ''
      },
      adddialog: false,
      checkBoxMore: false,
      radioMore: false,
      editMore: false,
      editCheckBoxMore: false,
      editRadioMore: false,
      editTypes: [
        {
          name: '文本',
          type: 'input'
        },
        {
          name: '下拉菜单',
          type: 'select'
        },
        {
          name: '时间',
          type: 'datePicker'
        },
        {
          name: '地址',
          type: 'addressPicker'
        },
        {
          name: '单选',
          type: 'radio'
        },
        {
          name: '复选',
          type: 'checkBox'
        }
      ],
      types: [
        {
          name: '文本',
          type: 'input'
        },
        {
          name: '下拉菜单',
          type: 'select'
        },
        {
          name: '时间',
          type: 'datePicker'
        },
        {
          name: '地址',
          type: 'addressPicker'
        },
        {
          name: '单选',
          type: 'radio'
        },
        {
          name: '复选',
          type: 'checkBox'
        }
      ],
      tabIndex: 0,
      editTabIndex: 0,
      addMore: false,
      timeChoose: [
        {
          name: '日期',
          dateType: 'datePicker'
        },
        {
          name: '日期和时间',
          dateType: 'dateTimePicker'
        }
      ],
      dateTabIndex: 0,
      editSystem: '',
      rules: {
        name: [
          { required: true, message: '请输入属性名称', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请输入字段标识', trigger: 'blur' }
        ],
        score: [
          { required: true, message: '请输入评分标准', trigger: 'blur' }
        ],
        attr_type: [
          { required: true, message: '请选择属性类型', trigger: 'blur' }
        ]
      },
      ruless: {
        name: [
          { required: true, message: '请输入属性名称', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请输入字段标识', trigger: 'blur' }
        ],
        score: [
          { required: true, message: '请输入评分标准', trigger: 'blur' }
        ],
        attr_type: [
          { required: true, message: '请选择属性类型', trigger: 'blur' }
        ]
      },
      editId: '',
      lr: '',
      transAttr: [],
      useData: [],
      flag: 0,
      isChange: 0
    }
  },
  methods: {
    // 切换属性分组
    changeGroup(val) {
      getCusAttrLeftList(val).then((res) => {
        this.leftData = []
        this.rightData = []
        if (res.data.code == 200) {
          for (let item of res.data.result) {
            this.leftData.push({
              key: item.identity,
              label: item.name,
              disabled: false,
              id: item.id
            })
          }
          this.rightData = this.transAttr
          console.log('this.rightData', this.rightData)
        }
      })
    },
    // 穿梭框确认添加
    confirmAttrTransAdd() {
      if (this.isChange === 0) {
        _g.toastMsg('error', '请选择属性')
        return
      }
      if (this.flag === 0) {
        this.flag = 1
        let modelId = this.$route.query.id
        setTransAddDel(modelId, this.transAttr.join(',')).then((res) => {
          if (res.data.code == 200) {
            this.flag = 0
            _g.toastMsg('success', res.data.message)
            this.chooseBothdialog = false
            this.getCustomerAttributeList()
          } else {
            this.flag = 0
            _g.toastMsg('error', res.data.message)
            this.chooseBothdialog = false
          }
        })
      }
    },
    // 穿梭框的change
    chooseTrans(val, lr, arr) {
      console.log('02', val, lr, arr)
      this.isChange = 1
      this.lr = lr
      if (lr === 'right') {
        let arrs = JSON.parse(JSON.stringify(val))
        for (let item of arrs) {
          this.transAttr.push(item)
        }
        console.log('523', this.transAttr)
        this.transAttr = Array.from(new Set(this.transAttr))
      } else {
        for (let item of arr) {
          for (let one of this.transAttr) {
            if (item === one) {
              let index = this.transAttr.indexOf(item)
              this.transAttr.splice(index, 1)
            }
          }
        }
      }
      console.log('521', this.rightData)
      console.log('522', this.transAttr)
    },
    // 加载穿梭框左侧属性
    getCusAttrLeftLists() {
      this.leftData = []
      this.rightData = []
      this.groupId = 0
      getCusAttrLeftList(this.groupId).then((res) => {
        if (res.data.code == 200) {
          for (let item of res.data.result) {
            this.leftData.push({
              key: item.identity,
              label: item.name,
              disabled: false,
              id: item.id
            })
          }
          console.log('1011', this.leftData)
          console.log('this.useData', this.useData)
          for (let item of this.leftData) {
            for (let one of this.useData) {
              if (item.key === one.identity) {
                this.rightData.push(one.identity)
                console.log('520')
              }
            }
          }
          this.transAttr = this.rightData
          console.log('this.rightData', this.rightData)
        }
      })
    },
    // 编辑的关联类型
    chooseEditAttrType(val) {
      this.editForm.about_real_content = ''
      getCusAttrList(val).then((res) => {
        if (res.data.code == 200) {
          let normal = []
          for (let attr of res.data.result) {
            if (attr.isNormal !== 0) {
              normal.push(attr)
            }
          }
          this.about_content = normal
        }
      })
    },
    // 选择关联的类型
    chooseAttrAboutType(val) {
      this.addForm.about_real_content = ''
      getCusAttrList(val).then((res) => {
        if (res.data.code == 200) {
          let normal = []
          for (let attr of res.data.result) {
            if (attr.isNormal !== 0) {
              normal.push(attr)
            }
          }
          this.about_content = normal
        }
      })
    },
    log(evt) {
      window.console.log(evt)
      console.log('normal', this.normal)
      let arr = []
      if (evt.moved.element.isNormal === 1) {
        for (let i in this.normal) {
          arr.push({
            id: this.normal[i].id,
            sort: i
          })
        }
      } else {
        for (let j in this.notNormal) {
          arr.push({
            id: this.notNormal[j].id,
            sort: j
          })
        }
      }
      let modelId = this.$route.query.id
      sortCustomerAttr(arr, modelId).then((res) => {
        if (res.data.code == 200) {
          _g.toastMsg('success', '排序成功')
          this.getCustomerAttributeList()
        }
      })
    },
    // 打开公共属性弹窗
    openBothAttr() {
      this.getCusAttrLeftLists()
      this.chooseBothdialog = true
    },
    // 选择添加属性类型
    chooseAttrType(val) {
      this.addForm.type = val
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAddAttr()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 确认编辑属性
    confirmEditAttr() {
      if (this.editForm.type === 'input' || this.editForm.type === 'datePicker' || this.editForm.type === 'addressPicker' || this.editForm.type === 'dateTimePicker') {
        this.editForm.option = []
      } else if (this.editForm.type === 'select') {
        this.editForm.option = this.editForm.radio
      } else if (this.editForm.type === 'radio') {
        this.editForm.option = this.editForm.radio
      } else if (this.editForm.type === 'multipleSelect') {
        this.editForm.option = this.editForm.checkBox
      } else if (this.editForm.type === 'model') {
        console.log('this.editForm.option', this.editForm.option)
        this.editForm.option = []
        this.editForm.option.push({
          modelId: this.editForm.about_cus_type
        })
        this.editForm.option.push({
          attrId: this.editForm.about_real_content
        })
        for (let item of this.about_content) {
          if (item.id === this.editForm.about_real_content) {
            this.editForm.option.push({
              identity: item.identity
            })
            break
          }
        }
      }
      if (this.editForm.type === 'time') {
        this.editForm.type = this.editForm.realtype
      }
      let required = 2
      if (this.editForm.checked === false) {
        required = 0
      } else {
        required = 1
      }
      if (this.editForm.score === '') {
        _g.toastMsg('error', '评分标准不能为空')
        return
      }
      if (isNaN(this.editForm.score)) {
        _g.toastMsg('error', '评分标准必须是数字')
        return
      }
      if (this.editForm.name === '') {
        _g.toastMsg('error', '属性名称不能为空')
        return
      }
      this.editForm.option = JSON.stringify(this.editForm.option)
      let model_id = this.$route.query.id
      this.disabledEdit = true
      editCustomerAttr(this.editForm.name, this.editForm.score, this.editForm.option, required, this.editId, model_id).then((res) => {
        if (res.data.code == 200) {
          this.editdialog = false
          this.disabledEdit = false
          this.getCustomerAttributeList()
          _g.toastMsg('success', '编辑成功')
        } else {
          this.disabledEdit = false
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 确认添加属性
    confirmAddAttr() {
      if (this.addForm.type === 'input' || this.addForm.type === 'datePicker' || this.addForm.type === 'addressPicker' || this.addForm.type === 'dateTimePicker') {
        this.addForm.option = []
      } else if (this.addForm.type === 'select') {
        this.addForm.option = this.addForm.radio
      } else if (this.addForm.type === 'radio') {
        this.addForm.option = this.addForm.radio
      } else if (this.addForm.type === 'multipleSelect') {
        this.addForm.option = this.addForm.checkBox
      } else if (this.addForm.type === 'model') {
        this.addForm.option = []
        this.addForm.option.push({
          modelId: this.addForm.about_cus_type
        })
        this.addForm.option.push({
          attrId: this.addForm.about_real_content
        })
        for (let item of this.about_content) {
          if (item.id === this.addForm.about_real_content) {
            this.addForm.option.push({
              identity: item.identity
            })
            break
          }
        }
      }
      if (this.addForm.type === 'time') {
        this.addForm.type = this.addForm.realtype
      }
      this.addForm.option = JSON.stringify(this.addForm.option)
      let model_id = this.$route.query.id
      let required = 2
      if (this.addForm.checked === false) {
        required = 0
      } else {
        required = 1
      }
      if (this.addForm.score === '') {
        _g.toastMsg('error', '评分标准不能为空')
        return
      }
      if (isNaN(this.addForm.score)) {
        _g.toastMsg('error', '评分标准必须是数字')
        return
      }
      if (this.addForm.name === '') {
        _g.toastMsg('error', '属性名称不能为空')
        return
      }
      if (this.addForm.identity === '') {
        _g.toastMsg('error', '属性ID不能为空')
        return
      }
      if (this.addForm.type === 'model') {
        console.log('this.addForm.about_cus_type', this.addForm.about_cus_type)
        if (typeof this.addForm.about_cus_type === 'undefined') {
          _g.toastMsg('error', '请选择受众类型')
          return
        }
        if (this.addForm.about_real_content === '') {
          _g.toastMsg('error', '请选择关联字段')
          return
        }
      }
      let regex = new RegExp('^[A-Za-z][A-Za-z_]+$')
      if (regex.test(this.addForm.identity) === false) {
        _g.toastMsg('error', '属性ID必须为字母,以字母开头,两个单词之间用下划线连接')
        return
      }
      this.disabled = true
      addCustomerAttr(this.addForm.name, this.addForm.identity, this.addForm.score, this.addForm.type, this.addForm.option, model_id, required, 'test', 1, 0).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.adddialog = false
          this.disabled = false
          this.getCustomerAttributeList()
          _g.toastMsg('success', '添加成功')
        } else {
          this.disabled = false
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 删除属性
    removeCustomerAttribute(item) {
      this.$confirm('确认删除该属性?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomerAttr(item.id).then((res) => {
          if (res.data.code == 200) {
            this.getCustomerAttributeList()
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 删除添加checkBox可选项
    removeCheckBoxItem(index) {
      this.addForm.checkBox.splice(index, 1)
      if (this.addForm.checkBox.length === 1) {
        this.checkBoxMore = false
      }
    },
    // 删除编辑radio可选项
    removeEditRadioItem(index) {
      this.editForm.radio.splice(index, 1)
      if (this.editForm.radio.length === 1) {
        this.editRadioMore = false
      }
    },
    // 删除编辑checkBox可选项
    removeEditCheckBoxItem(index) {
      this.editForm.checkBox.splice(index, 1)
      if (this.editForm.checkBox.length === 1) {
        this.editCheckBoxMore = false
      }
    },
    // 增加添加checkBox可选项
    addCheckBoxItem() {
      this.addForm.checkBox.push('')
      this.checkBoxMore = true
    },
    // 增加编辑checkBox可选项
    addEditCheckBoxItem() {
      this.editForm.checkBox.push('')
      this.editCheckBoxMore = true
    },
    // 增加编辑radio可选项
    addEditRadioItem() {
      this.editForm.radio.push('')
      this.editRadioMore = true
    },
    // 选择时间类型
    chooseDateType(index, item) {
      this.dateTabIndex = index
      this.addForm.realtype = item.dateType
      this.editForm.realtype = item.dateType
    },
    // 删除添加select可选项
    removeSelectItem(index) {
      this.addForm.select.splice(index, 1)
      if (this.addForm.select.length === 1) {
        this.addMore = false
      }
    },
    // 删除添加radio可选项
    removeRadioItem(index) {
      this.addForm.radio.splice(index, 1)
      if (this.addForm.radio.length === 1) {
        this.radioMore = false
      }
    },
    // 删除编辑select可选项
    removeEditSelectItem(index) {
      this.editForm.select.splice(index, 1)
      if (this.editForm.select.length === 1) {
        this.editMore = false
      }
    },
    // 增加添加select可选项
    addSelectItem() {
      this.addForm.select.push('')
      this.addMore = true
    },
    // 增加编辑select可选项
    addEditSelectItem() {
      this.editForm.select.push('')
      this.editMore = true
    },
    // 增加添加radio可选项
    addRadioItem() {
      this.addForm.radio.push('')
      this.radioMore = true
    },
    // 选择属性类型
    chooseType(index, item) {
      this.tabIndex = index
      this.addForm.type = item.type
    },
    // 添加属性
    addAttr() {
      this.adddialog = true
      this.addMore = false
      // 清空弹窗内容
      this.addForm.name = ''
      this.addForm.score = ''
      this.addForm.attr_type = 'input'
      this.tabIndex = 0
      this.dateTabIndex = 0
      this.addForm.type = 'input'
      this.addForm.identity = ''
      this.addForm.is_normal = 1
      this.addForm.select = ['']
      this.addForm.checkBox = ['']
      this.addForm.radio = ['']
    },
    // 获取数据列表
    getCustomerAttributeList() {
      this.loadingTable = true
      this.rightData = []
      let id = this.$route.query.id
      getCusAttrList(id, 1).then((res) => {
        if (res.data.code == 200) {
          let normal = []
          let notNormal = []
          for (let attr of res.data.result.audienceAttrList) {
            if (attr.isNormal === 0) {
              notNormal.push(attr)
            } else {
              normal.push(attr)
            }
          }
          this.normal = normal
          this.notNormal = notNormal
          // 给穿梭框右侧的数据
          let arr = JSON.parse(JSON.stringify(res.data.result.audienceAttrList))
          this.useData = arr
        }
        this.loadingTable = false
      })
      // this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 打开编辑弹窗
    openDialog(item) {
      this.editdialog = true
      this.editSystem = item.is_system
      if (item.type === 'datePicker' || item.type === 'dateTimePicker') {
        this.editForm.attr_type = 'time'
        this.editForm.type = 'time'
      } else {
        this.editForm.attr_type = item.type
        this.editForm.type = item.type
      }
      this.editId = item.id
      if (item.type === 'model') {
        // 解析json 捕获异常
        let options = []
        try {
          options = JSON.parse(item.options)
        } catch (error) {
          console.log(error)
        }
        this.editForm.about_cus_type = options[0].modelId
        getCusAttrList(options[0].modelId).then((res) => {
          if (res.data.code == 200) {
            let normal = []
            for (let attr of res.data.result) {
              if (attr.isNormal !== 0) {
                normal.push(attr)
              }
            }
            this.about_content = normal
            console.log('da', normal)
            for (let one of this.about_content) {
              if (parseInt(options[1].attrId) === one.id) {
                this.editForm.about_real_content = options[1].attrId
                break
              } else {
                this.editForm.about_real_content = ''
              }
            }
          }
        })
      }
      this.editForm.name = item.name
      this.editForm.score = item.score
      this.editForm.identity = item.identity
      if (item.required === 0) {
        this.editForm.checked = false
      } else {
        this.editForm.checked = true
      }
      this.editForm.is_system = item.is_system
      if (item.is_system === 0) {
        this.isSystem = false
      } else {
        this.isSystem = true
      }
      let arr = JSON.parse(item.options)
      if (item.type === 'input') {
        this.editTabIndex = 0
      } else if (item.type === 'select') {
        this.editTabIndex = 1
        this.editForm.radio = arr
      } else if (item.type === 'datePicker' || item.type === 'dateTimePicker') {
        this.editTabIndex = 2
        if (item.type === 'datePicker') {
          this.dateTabIndex = 0
        } else if (item.type === 'dateTimePicker') {
          this.dateTabIndex = 1
        }
      } else if (item.type === 'addressPicker') {
        this.editTabIndex = 3
      } else if (item.type === 'radio') {
        this.editTabIndex = 4
        this.editForm.radio = arr
        console.log(this.editForm.radio)
      } else if (item.type === 'multipleSelect') {
        this.editTabIndex = 5
        this.editForm.checkBox = arr
      }
    },
    setCustomerAttribute(isNormal, key) {
      customerAttrIsNormal(isNormal, key.id).then((res) => {
        if (res.data.code == 200) {
          this.getCustomerAttributeList()
          _g.toastMsg('success', '设置成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取受众类型列表
    load() {
      getCusTypes().then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          let id = this.$route.query.id
          for (let i in res.data.result) {
            if (parseInt(id) === res.data.result[i].id) {
              res.data.result.splice(i, 1)
            }
          }
          this.about_cus_types = res.data.result
        }
      })
    },
    // 获取属性群组列表
    loadAttrGroupList() {
      getSetAttrGroupList().then((res) => {
        if (res.data.code == 200) {
          res.data.result.unshift({
            id: 0,
            name: '全部'
          })
          this.groups = res.data.result
        }
      })
    }
  },
  created() {
    this.hide = true
    this.getCustomerAttributeList()
    this.load()
    this.loadAttrGroupList()
  }
}
</script>

<style scoped>
  .blankOrder {
    background-color: #ffffff;
    width: 100%;
    text-align: center;
    padding: 20px 0;
  }
.description-date{
  width: 76%;
  color: #39C6CD;
  padding-left: 24%;
  text-align: left;
}
.text-align-left{
  text-align: left;
}
.date-type{
  width: 203px;
  display: flex;
  justify-content: space-between;
}
.date-type .dateChoose{
  border: 1px solid #39C6CD!important;
  color: #39C6CD!important;
}
.date-type div{
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #666;
  border: 1px solid #e5e5e5;
  cursor: pointer;
}
.date-type div:first-child{
  border-right: none;
}
::-webkit-scrollbar
{
  width: 6px;  /*滚动条宽度*/
  height: 16px;  /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;  /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5;/*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
  border-radius: 10px;  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #ccc;  /*滚动条的背景颜色*/
}
.addSelectItem{
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #84AAFF;
  text-align: right;
  cursor: pointer;
}
.removeSelectItem{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: red;
  text-align: right;
  cursor: pointer;
  padding-right: 10%;
}
.addMore{
  height: 300px;
  overflow: auto;
}
.normal{
  height: auto;
  overflow: hidden;
}
.tabs{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
}
.tabs div{
  width: 82px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #666;
  border:1px solid #e5e5e5;
  border-left: none;
  cursor: pointer;
}
.tabs div:first-child{
  border: 1px solid #e5e5e5;
}
.tabs .type-select{
  border:1px solid #39C6CD!important;
  color: #39C6CD;
}
.tabs .edit-type-select{
  border:1px solid #39C6CD!important;
  color: #39C6CD;
  background: #ccc!important;
}
.addAttr{
  display: block;
  padding: 0 15px;
  height: 30px;
  background: #4882ff;
  color: #fff;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  float: right;
  margin-top: 5px;
  cursor: pointer;
}
.base-input {
  margin-top: 10px;
}
/*修改列表页input输入框*/
.base-input .el-input__inner {
  width: 180px!important;
  height: 36px!important;
}
.base-input .el-input{
  width: 180px!important;
}
.base-input .search-list-nav-select{
  width: 180px;
}
.base-input .search-list-nav{
  padding-bottom: 0;
  padding-top: 0;
}
.data-list-nav{
  padding-top: 10px;
  height: 38px;
}
/*搜索框*/
.el-icon-search {
  font-family: element-icons!important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased
}
.search-content {
  padding:10px;
  background: #fff;
  border: 1px solid #ebebeb;
  text-align: left;
}
.search-content span {padding-left: 10px;}
a.op-link{color:#4882ff;font-size: 14px}
.text-align-right{
  text-align: right
}
.table-foot {
  background: #fff;
  padding:10px;
  height:40px;
}
.table-foot-pagination {
  float: right;
}
.table-foot-pagination .el-input__inner {
  width: 100px !important;
}

/*表格数据居中*/
.el-table th>.cell, .el-table .cell{text-align: center}
.order-list-search-span {
  /*display: block;*/
  /*float: left;*/
}
.search-content-row {
  margin-top: 20px;
  text-align: left;
}
.table-foot-pagination{
  float: right;
}
.table-foot-pagination .el-pagination{
  margin-bottom: 10px;
  margin-right: 40px;
}
.customer-procuct-table {
  margin-top: 0px;
}
</style>
